import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Stack,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";

const trainingDemoVideo = "https://www.w3schools.com/html/mov_bbb.mp4";

const videos = [
  {
    id: 1,
    title: "Using General Q&A",
    description: "Ask RepAssist any product or HCP question instantly.",
    duration: "8 min",
    label: "Q&A",
  },
  {
    id: 2,
    title: "HCP Interaction Prep",
    description:
      "Prepare for calls with AI-powered summaries and talking points.",
    duration: "11 min",
    label: "HCP",
  },
  {
    id: 3,
    title: "How to Log Calls",
    description: "Capture visit notes and outcomes directly in RepAssist.",
    duration: "6 min",
    label: "Logging",
  },
  {
    id: 4,
    title: "Analyzing Territory Data",
    description: "Review your prescribing trends and territory performance.",
    duration: "14 min",
    label: "Analytics",
  },
  {
    id: 5,
    title: "AI Prompting Best Practices",
    description: "Get better answers by asking better questions.",
    duration: "9 min",
    label: "AI Tips",
  },
  {
    id: 6,
    title: "Compliance & Safety Info",
    description:
      "How RepAssist handles regulatory guardrails and safety queries.",
    duration: "7 min",
    label: "Compliance",
  },
];

function TutorialVideos() {
  const [hoveredId, setHoveredId] = useState(null);
  const [openVideo, setOpenVideo] = useState(false);

  const handleOpenVideo = () => setOpenVideo(true);
  const handleCloseVideo = () => setOpenVideo(false);

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              color: "#202020",
            }}
          >
            Tutorial Videos
          </Typography>

          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#396D87",
              cursor: "pointer",
            }}
          >
            View all
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {videos.map((video) => (
            <Grid item xs={12} sm={6} lg={4} key={video.id}>
              <Paper
                elevation={0}
                onMouseEnter={() => setHoveredId(video.id)}
                onMouseLeave={() => setHoveredId(null)}
                onClick={handleOpenVideo}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "16px",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  transition: "0.2s ease",
                  "&:hover": {
                    boxShadow: "0px 8px 18px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: 150,
                    background:
                      "linear-gradient(135deg, rgba(59,130,246,0.18), rgba(59,130,246,0.05))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 12,
                      left: 12,
                      fontSize: "10px",
                      fontWeight: 700,
                      px: 1.2,
                      py: 0.5,
                      borderRadius: "999px",
                      backgroundColor: "rgba(255,255,255,0.85)",
                      color: "#444",
                    }}
                  >
                    {video.label}
                  </Box>

                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transform:
                        hoveredId === video.id ? "scale(1.1)" : "scale(1)",
                      transition: "transform 0.15s ease",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                    }}
                  >
                    <PlayArrowIcon sx={{ color: "#396D87" }} />
                  </Box>
                </Box>

                <Box sx={{ p: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#202020",
                      mb: 0.8,
                    }}
                  >
                    {video.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#666666",
                      lineHeight: 1.6,
                      mb: 1.8,
                    }}
                  >
                    {video.description}
                  </Typography>

                  <Stack direction="row" spacing={0.7} alignItems="center">
                    <AccessTimeIcon sx={{ fontSize: 15, color: "#666666" }} />
                    <Typography sx={{ fontSize: "12px", color: "#666666" }}>
                      {video.duration}
                    </Typography>
                  </Stack>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* VIDEO MODAL */}
      <Dialog
        open={openVideo}
        onClose={handleCloseVideo}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "#000",
          },
        }}
      >
        <DialogContent
          sx={{ p: 0, position: "relative", backgroundColor: "#000" }}
        >
          <IconButton
            onClick={handleCloseVideo}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 2,
              backgroundColor: "rgba(255,255,255,0.15)",
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          {openVideo && (
            <video
              controls
              autoPlay
              playsInline
              style={{
                width: "100%",
                maxHeight: "80vh",
                background: "#000",
              }}
            >
              <source src={trainingDemoVideo} type="video/mp4" />
            </video>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TutorialVideos;
